import { render } from "./TextNote.vue?vue&type=template&id=20f87098"
import script from "./TextNote.vue?vue&type=script&lang=js"
export * from "./TextNote.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Input/TextNote.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20f87098"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20f87098', __exports__)) {
    api.reload('20f87098', __exports__)
  }
  
  module.hot.accept("./TextNote.vue?vue&type=template&id=20f87098", () => {
    api.rerender('20f87098', render)
  })

}


export default __exports__